import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { BASE_URL } from '@/constants/endpoints';

export const request = (token?: string, version?: string) => {
  return axios.create({
    baseURL: BASE_URL(version),
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const setRequestRetry = (client: AxiosInstance, retries?: number) => {
  axiosRetry(client, {
    retries: retries ?? 3,
    retryDelay: retryCount => {
      return retryCount * 1000;
    }
  });
};
